import { extend } from 'flarum/common/extend';
import createLightbox from '../utils/createLightbox';
/** Attach independent DOM link galleries to a Flarum component. */
export default class Gallery {
  constructor(component, selector, options = {}) {
    this.component = component;
    this.selector = selector;
    this.options = options;
  }
  extend(app, extension) {
    const target = typeof this.component === 'string' ? this.component : this.component.prototype;
    const selector = this.selector;
    const children = this.options.children ?? 'a[data-pswp], a.FoFUpload--Upl-Image-Preview-Link';
    const galleries = new WeakMap();
    extend(target, ['oncreate', 'onupdate'], function (_result, vnode) {
      // Component.element is set only oncreate; vnode.dom also tracks a replaced root.
      const root = vnode.dom;
      const containers = new Set();
      if (root instanceof HTMLElement) {
        if (root.matches(selector)) containers.add(root);
        root.querySelectorAll(selector).forEach(container => containers.add(container));
      }
      const instances = galleries.get(this) ?? new Map();
      galleries.set(this, instances);
      instances.forEach((destroy, container) => {
        if (!containers.has(container)) {
          destroy();
          instances.delete(container);
        }
      });
      containers.forEach(container => {
        if (!instances.has(container)) {
          instances.set(container, createLightbox(app, container, children));
        }
      });
    });
    extend(target, 'onremove', function () {
      galleries.get(this)?.forEach(destroy => destroy());
      galleries.delete(this);
    });
  }
}
flarum.reg.add('fof-photoswipe', 'forum/extenders/Gallery', Gallery);